import debounce from 'lodash/debounce'
import pick from 'lodash/pick'
import LocalStorageMock from './localStorageMock'

if (typeof localStorage === 'undefined' || localStorage === null) {
  global.localStorage = new LocalStorageMock()
}

// Note: CACHE_STATE_KEYS and STORAGE_KEY are globals defined via build config
// eslint-disable-next-line no-undef
const cacheStateKeys = JSON.parse(typeof CACHE_STATE_KEYS !== 'undefined' ? CACHE_STATE_KEYS : '{}')
// eslint-disable-next-line no-undef
const state = JSON.parse(localStorage.getItem(typeof STORAGE_KEY !== 'undefined' ? STORAGE_KEY : 'reggora_state') || '{}')

const middleware = store => next => action => {
  const result = next(action)
  const nextState = store.getState()

  cacheState(
    cacheStateKeys ? pick(nextState, cacheStateKeys) : nextState
  )

  return result
}

const cacheState = debounce(function(state) {
  localStorage.setItem(
    // eslint-disable-next-line no-undef
    STORAGE_KEY,
    JSON.stringify(state)
  )
})

export { middleware, state }
